import { BaseApi } from './base.api.js';

export class WorkflowInstanceApi extends BaseApi {
    constructor(client) {
        super(client, '/workflow-instances');
    }

    async start(payload) {
        return this.client.post(this.basePath, payload || {});
    }

    async cancel(id, payload) {
        return this.client.post(`${this.basePath}/${id}/cancel`, payload || {});
    }

    async suspend(id, payload) {
        return this.client.post(`${this.basePath}/${id}/suspend`, payload || {});
    }

    async resume(id, payload) {
        return this.client.post(`${this.basePath}/${id}/resume`, payload || {});
    }

    async injectApprovers(id, payload) {
        return this.client.post(`${this.basePath}/${id}/inject-approvers`, payload || {});
    }

    async emergencyComplete(id, payload) {
        return this.client.post(`${this.basePath}/${id}/emergency-complete`, payload || {});
    }
}
